module.exports = new __parcel__URL__("favicon-temp-jsm.45cc4563.png").toString();